import DevHubIcon from './logo/BCID_V_RGB_rev.svg';

export const LogoIcon = () => {
  return (
    <img
      width="64px"
      height="auto"
      alt="Government of B.C. logo"
      src={DevHubIcon}
    />
  );
};
